import React, { useState } from "react";
import {
  faChevronDown,
  faChevronUp,
  faTrash,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  OPTIONS_DATA_MAPPER,
  returnOnlyIfBoolean,
  yesNoOptions,
  toOptionValuesFromMapper,
} from "../../utils";
import { get } from "lodash";
import AddToolTip from "../AddToolTip";
import { Field } from "formik";
import {
  FieldButtonGroup,
  FieldDropSide,
  FieldInput,
  FieldInputDollar,
  FieldInputDollarBox,
  FieldInputNumber,
  FieldInputPercentage,
  FieldInputPercentageBox,
} from "../Forms";
import SearchableList from "../SearchableList";
import { Link } from "react-router-dom";
import BankDetails from "../BankDetails";
import AddressDetails from "../AddressDetails";
import { faTrashAlt } from "@fortawesome/pro-solid-svg-icons";
import "../../styles/components/DistributionCard.scss";
import { useDeepEffect } from "../../abstracts";
import {
  CalculateSourceSplit,
  getTotalFees,
} from "../../containers/Distribution/WithdrawalRequestContainer/CalculateSourceSplitup";
import { isEmpty } from "lodash-es";
import { getFilteredRkData } from "../../containers/Distribution/WithdrawalRequestContainer/DistributionConstantsAndFunctions";

const DistributionCard = (props) => {
  const {
    fields,
    bankAdded,
    setBankAdded,
    setFieldValue,
    addressList,
    handleChange,
    values,
    bankList,
    setAddWithdrawal,
    setBankInformationDetails,
    responseModel,
    setValues,
    setBankSlideOpen,
    setSliderOpen3,
    setAddress,
    addressAdded,
    setAddressAdded,
    setAddressSlideOpen,
    setSourceSplit,
    setsourcesplitupslide,
    set,
    data,
    index,
    rkData,
    distLength,
    deleteComponent,
    setDistribution,
    distribution,
    sourceSplit,
    beneficiaries,
    address,
    bankInformationDetails,
    withdrawal,
    vestedBalance,
    stateList,
    setTransactionIndex,
    availableAmount,
    setAvailableAmount,
  } = props;
  const withdrawalTransactionId = data.id ? data.id : 0;
  const [show, setShow] = useState(true);
  const balance =
    index == 0
      ? vestedBalance
      : getFilteredRkData(
          sourceSplit[index - 1]?.updatedSourceSplit,
          false,
          withdrawal,
          data
        )?.reduce((x, y) => x + y.accountBalance, 0);
  const codeOptionsRollOver = toOptionValuesFromMapper(
    OPTIONS_DATA_MAPPER.CODE_OPTIONS_ROLLOVER
  );
  const codeOptionsCash = toOptionValuesFromMapper(
    OPTIONS_DATA_MAPPER.CODE_OPTIONS_CASH
  );
  const payeeOptions = toOptionValuesFromMapper(
    OPTIONS_DATA_MAPPER.PAYEE_OPTIONS
  );
  const waiveOffReasonOptions = toOptionValuesFromMapper(
    OPTIONS_DATA_MAPPER.WAIVEOFF_REASON_OPTIONS
  );
  const distributionModes = toOptionValuesFromMapper(
    OPTIONS_DATA_MAPPER.DISTRIBUTION_MODES
  );
  const distributionModesForInservice = toOptionValuesFromMapper(
    OPTIONS_DATA_MAPPER.DISTRIBUTION_MODES_INSERVICE
  );
  const paymentOptions = toOptionValuesFromMapper(
    OPTIONS_DATA_MAPPER.PAYMENT_OPTIONS
  );

  const hideCard = () => {
    setShow(!show);
  };

  const onBeneficiaryChange = (value) => {
    if (value || value === 0) {
      setFieldValue(
        `[distribution]${index}.beneficiaryId`,
        beneficiaries[value].id
      );
      setFieldValue(
        `[distribution]${index}.beneficiaryName`,
        beneficiaries[value].name
      );
    } else {
      setFieldValue(`[distribution]${index}.beneficiaryId`, null);
      setFieldValue(`[distribution]${index}.beneficiaryName`, null);
    }
  };

  const CalculateAvailableAmount = () => {
    var withdrawalAmount = withdrawal?.maximumWithDrawalLimitAmount ?? 0;
    if (index == 0) {
      var amount = getFilteredRkData(rkData, false, withdrawal, data)?.reduce(
        (x, y) => x + y.accountBalance,
        0
      );
      return amount < withdrawalAmount ? amount : withdrawalAmount;
    }
    var updatedBalance = getFilteredRkData(
      sourceSplit[index - 1]?.updatedSourceSplit,
      false,
      withdrawal,
      data
    )?.reduce((x, y) => x + y.accountBalance, 0);
    var y = 0;
    var x = sourceSplit?.map((a, i) => {
      if (i < index) y += a?.grossWithdrawalAmount;
    });
    var updatedWithdrawalAmount = withdrawalAmount - y;
    return updatedBalance < updatedWithdrawalAmount
      ? updatedBalance
      : updatedWithdrawalAmount;
  };

  useDeepEffect(() => {
    if (data.distributionMode) {
      var amount = CalculateAvailableAmount();
      availableAmount[index] = amount;
      setAvailableAmount(availableAmount);
      sourceSplit[index] = CalculateSourceSplit(
        index == 0 ? rkData : sourceSplit[index - 1]["updatedSourceSplit"],
        data,
        withdrawal,
        values,
        index >= (sourceSplit?.length ?? 0) ||
          index == (sourceSplit?.length ?? 0) - 1,
        values?.withdrawEntireAmount ? 1 : 2,
        amount
      );
      setAddWithdrawal(
        parseFloat(
          sourceSplit
            ?.reduce((x, y) => x + y?.grossWithdrawalAmount, 0)
            ?.toFixed(2) || 0
        ) < parseFloat(availableAmount[0]?.toFixed(2) || 0)
      );
      setTransactionIndex(index);
      var netAmount = sourceSplit[index]?.requestedAmount;
      setFieldValue(
        `[distribution]${index}.${fields.requestedAmount}`,
        parseFloat(netAmount)
      );
    }
  }, [
    values.withdrawEntireAmount,
    data.distributionMode,
    values.withdrawalType,
  ]);

  useDeepEffect(() => {
    setAddWithdrawal(
      parseFloat(
        sourceSplit
          ?.reduce((x, y) => x + y?.grossWithdrawalAmount, 0)
          ?.toFixed(2) || 0
      ) < parseFloat(availableAmount[0]?.toFixed(2) || 0)
    );
  }, [data?.requestedAmount]);

  const totalFees = getTotalFees(values.distribution[index]) ?? 0;

  return (
    <div className="withdrawal-card">
      <div className="withdrawalCard-header border-bottom">
        <p className="ft-16 fw-500 Dark-Grey-Color">
          {index + 1} of {distLength} Withdrawal
        </p>
        {show ? (
          <FontAwesomeIcon
            className="fw-400 ft-18 blue-text mr-10"
            icon={faChevronUp}
            onClick={() => hideCard()}
          />
        ) : (
          <FontAwesomeIcon
            className="fw-400 ft-18 blue-text mr-10"
            icon={faChevronDown}
            onClick={() => hideCard()}
          />
        )}
      </div>
      <div className="d-flex flex-row justify-content-space-between align-items-center">
        <div className="d-flex flex-col">
          <p className="fw-400 ft-14 Grey-Color mt-10">
            Select Distribution Mode
          </p>
          <Field
            isRequired
            name={`[distribution]${index}.${fields.distributionMode}`}
            size="sm"
            //options={distributionModes}
            options={
              values.withdrawalType == 1 || values.withdrawalType == 2
                ? distributionModesForInservice
                : distributionModes.filter(
                    ({ value: x }) =>
                      !values.distribution.some(
                        ({ distributionMode: y }) => x === y
                      ) || x == data.distributionMode
                  )
            }
            selectedValue={data.distributionMode}
            onChange={(value) => {
              value == 1
                ? setFieldValue(
                    `[distribution]${index}.${fields.codeForRoleOver}`,
                    null
                  )
                : setFieldValue(`[distribution]${index}.${fields.code}`, null);
              setFieldValue(
                `[distribution]${index}.${fields.distributionMode}`,
                value
              );
            }}
            component={FieldButtonGroup}
          />
        </div>
        <FontAwesomeIcon
          className="fw-300 ft-14 orange-card mr-5 "
          icon={faTrashAlt}
          onClick={() => deleteComponent(index)}
        />
      </div>

      {data.distributionMode != null && show && (
        <>
          <p className="fw-400 ft-14 Grey-Color mt-10">
            Available withdrawal amount:{" "}
            <span className="fw-500 Black">
              ${" "}
              {availableAmount[index]?.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </span>
          </p>
          <p className="fw-400 ft-14 Grey-Color mt-10">Select 1099 Code</p>
          <Field
            size="md"
            name={
              // data.distributionMode == 1
              `[distribution]${index}.${fields.code}`
              // : `[distribution]${index}.${fields.codeForRoleOver}`
            }
            value={
              // data.distributionMode == 1
              data.code
              // : data.codeForRoleOver
            }
            options={
              data.distributionMode == 1 ? codeOptionsCash : codeOptionsRollOver
            }
            direction="right"
            placeholder="Select"
            popupContent={
              // data.distributionMode == 1 ? (
              <SearchableList
                label="Select a withdrawal type"
                options={
                  data.distributionMode == 1
                    ? codeOptionsCash
                    : codeOptionsRollOver
                }
                onSelect={(value) =>
                  setFieldValue(`[distribution]${index}.${fields.code}`, value)
                }
                selectedValue={data.code}
              />
              // ) : (
              // <SearchableList
              //   label="Select a withdrawal type"
              //   options={codeOptionsRollOver}
              //   onSelect={(value) =>
              //     setFieldValue(
              //       `[distribution]${index}.${fields.codeForRoleOver}`,
              //       value
              //     )
              //   }
              //   selectedValue={data.codeForRoleOver}
              // />
              // )
            }
            component={FieldDropSide}
          />
          <div className="d-flex flex-row mt-10 W-380 justify-content-space-between">
            {data.distributionMode == 1 && (
              <div className="d-flex flex-col">
                <Field
                  isRequired
                  name={`[distribution]${index}.${fields.payeeType}`}
                  label="Choose Payee"
                  size="sm"
                  options={payeeOptions}
                  selectedValue={data.payeeType}
                  onChange={(value) => {
                    setFieldValue(
                      `[distribution]${index}.${fields.payeeType}`,
                      value
                    );
                  }}
                  //disabled={isEdit && !isSave}
                  component={FieldButtonGroup}
                />
              </div>
            )}
            <div className="d-flex flex-col">
              <Field
                isRequired
                name={`[distribution]${index}.${fields.paymentMethod}`}
                label="Choose Payment Method"
                size="sm"
                options={paymentOptions.filter((x) =>
                  withdrawal
                    ? withdrawal?.paymentMethod.includes(x.value)
                    : data.paymentMethod
                )}
                selectedValue={data.paymentMethod}
                onChange={(value) => {
                  setFieldValue(
                    `[distribution]${index}.${fields.paymentMethod}`,
                    value
                  );
                  if (value === 1 && get(address, `0`)) {
                    setFieldValue(
                      `[distribution]${index}.address`,
                      get(address, `0`)
                    );
                  } else if (value === 2 && get(bankInformationDetails, `0`)) {
                    setFieldValue(
                      `[distribution]${index}.bank`,
                      get(bankInformationDetails, `0`)
                    );
                  }
                  sourceSplit[index] = CalculateSourceSplit(
                    index == 0
                      ? rkData
                      : sourceSplit[index - 1]["updatedSourceSplit"],
                    data,
                    withdrawal,
                    values,
                    index >= (sourceSplit?.length ?? 0) ||
                      index == (sourceSplit?.length ?? 0) - 1,
                    values?.withdrawEntireAmount &&
                      sourceSplit[index]?.grossWithdrawalAmount ==
                        availableAmount[index]
                      ? 1
                      : 2,
                    availableAmount[index]
                  );
                }}
                //disabled={isEdit && !isSave}
                component={FieldButtonGroup}
              />
            </div>
          </div>
          {data.distributionMode != 1 && (
            <>
              <Field
                isRequired
                name={`[distribution]${index}.${fields.iraNumber}`}
                label="Account/IRA number"
                size="md"
                type="text"
                autoComplete="off"
                value={data.iraNumber}
                onChange={handleChange}
                //disabled={isEdit && !isSave}
                component={FieldInputNumber}
              />
              <Field
                isRequired
                name={`[distribution]${index}.${fields.trusteeName}`}
                label="Company/Trustee name"
                size="md"
                type="text"
                autoComplete="off"
                value={data.trusteeName}
                onChange={handleChange}
                //disabled={isEdit && !isSave}
                component={FieldInput}
              />
              <Field
                isRequired
                name={`[distribution]${index}.${fields.planName}`}
                label="Plan Name"
                size="md"
                type="text"
                autoComplete="off"
                value={data.planName}
                onChange={handleChange}
                //disabled={isEdit && !isSave}
                component={FieldInput}
              />
            </>
          )}
          {data.payeeType == 2 && data.distributionMode == 1 && (
            <>
              <p className="fw-400 ft-14 Grey-Color mt-10">Benificiary name</p>

              <Field
                size="md"
                name={`[distribution]${index}.beneficiaryName`}
                value={data.beneficiaryName}
                direction="bottom"
                placeholder="Select a beneficiary"
                popupContent={
                  <SearchableList
                    label="Select a beneficiary"
                    options={
                      beneficiaries &&
                      beneficiaries.map((val, ind) => ({
                        label: val.name,
                        value: ind,
                      }))
                    }
                    onSelect={(value) => onBeneficiaryChange(value)}
                    selectedValue={values[fields.beneficiaryName]}
                  />
                }
                component={FieldDropSide}
              />
            </>
          )}
          {data.paymentMethod == 1 && (
            <div>
              <AddressDetails
                setAddressSlideOpen={setAddressSlideOpen}
                addressList={addressList}
                module="distribution"
                {...props}
                setAddress={setAddress}
                addressAdded={addressAdded}
                setAddressAdded={setAddressAdded}
                withdrawalTransactionId={withdrawalTransactionId}
              />
            </div>
          )}
          {data.paymentMethod == 2 && (
            <div>
              <BankDetails
                setBankSlideOpen={setBankSlideOpen}
                bankList={bankList}
                setBankInformationDetails={setBankInformationDetails}
                module="distribution"
                {...props}
                bankAdded={bankAdded}
                setBankAdded={setBankAdded}
              />
            </div>
          )}
          <div className="withdrawal-card">
            <div className="vestedbalance-header">
              <p className="ft-16 fw-500 Black">Vested Balance</p>
              <p className="ft-16 fw-500 Black">
                $
                {balance?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </p>
            </div>
            <div className="p-15">
              <div className="withdrawalCard-header border-bottom align-items-center mb-15">
                <div>
                  <p className="ft-16 fw-500 Dark-Grey-Color Account Holder">
                    Request amount
                  </p>
                  <p className="ft-10 fw-400 Dark-grey-Color">
                    Payment type
                    <span className="ft-12 fw-400 Black">- One time</span>
                  </p>
                </div>

                <div>
                  <Field
                    size="sm"
                    isRequired
                    name={`[distribution]${index}.${fields.requestedAmount}`}
                    type="text"
                    autoComplete="off"
                    value={data.requestedAmount}
                    precision={2}
                    onChange={(e) => {
                      setFieldValue(
                        `[distribution]${index}.${fields.requestedAmount}`,
                        parseFloat(e.target.value)
                      );
                      data.requestedAmount = parseFloat(e.target.value);
                      sourceSplit[index] = CalculateSourceSplit(
                        index == 0
                          ? rkData
                          : sourceSplit[index - 1]["updatedSourceSplit"],
                        data,
                        withdrawal,
                        values,
                        index >= (sourceSplit?.length ?? 0) ||
                          index == (sourceSplit?.length ?? 0) - 1
                      );
                      // setAddWithdrawal(sourceSplit?.reduce((x, y) => x + y?.grossWithdrawalAmount, 0)?.toFixed(2) < availableAmount[0]?.toFixed(2));
                      // handleChange(e);
                    }}
                    component={FieldInputDollarBox}
                  />
                </div>
              </div>
              <div className="withdrawalCard-header border-bottom align-items-center">
                <p className="ft-16 fw-500 Dark-Grey-Color Account Holder">
                  Fee
                </p>
                <div className="d-flex flex-col">
                  <>
                    {data.paymentMethod == 1 && (
                      <div className="d-flex flex-row align-items-center justify-content-space-between W-300">
                        <p className="mr-10">Check Fee</p>
                        <Field
                          size="sm"
                          isRequired
                          name={`[distribution]${index}.${fields.checkFee}`}
                          type="text"
                          autoComplete="off"
                          value={data.checkFee}
                          onChange={(val) => {
                            setFieldValue(
                              `[distribution]${index}.${fields.checkFee}`,
                              parseFloat(val.target.value)
                            );
                            data.checkFee = parseFloat(val.target.value);
                            sourceSplit[index] = CalculateSourceSplit(
                              index == 0
                                ? rkData
                                : sourceSplit[index - 1]["updatedSourceSplit"],
                              data,
                              withdrawal,
                              values,
                              index >= (sourceSplit?.length ?? 0) ||
                                index == (sourceSplit?.length ?? 0) - 1
                            );
                          }}
                          component={FieldInputDollarBox}
                        />
                      </div>
                    )}
                    {data.paymentMethod == 2 && (
                      <div className="d-flex flex-row align-items-center justify-content-space-between W-300">
                        <p className="mr-10">EFT Fee</p>
                        <Field
                          size="sm"
                          isRequired
                          name={`[distribution]${index}.${fields.eftFee}`}
                          type="text"
                          autoComplete="off"
                          value={data.eftFee}
                          onChange={(val) => {
                            setFieldValue(
                              `[distribution]${index}.${fields.eftFee}`,
                              parseFloat(val.target.value)
                            );
                            data.eftFee = parseFloat(val.target.value);
                            sourceSplit[index] = CalculateSourceSplit(
                              index == 0
                                ? rkData
                                : sourceSplit[index - 1]["updatedSourceSplit"],
                              data,
                              withdrawal,
                              values,
                              index >= (sourceSplit?.length ?? 0) ||
                                index == (sourceSplit?.length ?? 0) - 1
                            );
                          }}
                          component={FieldInputDollarBox}
                        />
                      </div>
                    )}
                  </>
                  {data.distributionMode == 1 ? (
                    <div className="d-flex flex-row align-items-center justify-content-space-between W-300">
                      <p className="mr-10">Withdrawal Fee</p>
                      <Field
                        size="sm"
                        isRequired
                        name={`[distribution]${index}.${fields.withdrawalFee}`}
                        type="text"
                        autoComplete="off"
                        value={data.withdrawalFee}
                        onChange={(val) => {
                          setFieldValue(
                            `[distribution]${index}.${fields.withdrawalFee}`,
                            parseFloat(val.target.value)
                          );
                          data.withdrawalFee = parseFloat(val.target.value);
                          sourceSplit[index] = CalculateSourceSplit(
                            index == 0
                              ? rkData
                              : sourceSplit[index - 1]["updatedSourceSplit"],
                            data,
                            withdrawal,
                            values,
                            index >= (sourceSplit?.length ?? 0) ||
                              index == (sourceSplit?.length ?? 0) - 1
                          );
                        }}
                        component={FieldInputDollarBox}
                      />
                    </div>
                  ) : (
                    <div className="d-flex flex-row align-items-center justify-content-space-between W-270">
                      <p className="mr-10">Rollover Fee</p>
                      <Field
                        size="sm"
                        isRequired
                        name={`[distribution]${index}.${fields.rollOverFee}`}
                        type="text"
                        autoComplete="off"
                        value={data.rollOverFee}
                        onChange={(val) => {
                          setFieldValue(
                            `[distribution]${index}.${fields.rollOverFee}`,
                            parseFloat(val.target.value)
                          );
                          data.rollOverFee = parseFloat(val.target.value);
                          sourceSplit[index] = CalculateSourceSplit(
                            index == 0
                              ? rkData
                              : sourceSplit[index - 1]["updatedSourceSplit"],
                            data,
                            withdrawal,
                            values,
                            index >= (sourceSplit?.length ?? 0) ||
                              index == (sourceSplit?.length ?? 0) - 1
                          );
                        }}
                        component={FieldInputDollarBox}
                      />
                    </div>
                  )}
                </div>

                <p className="ft-16 fw-500 Dark-Grey-Color Account Holder">
                  $ {totalFees?.toFixed(2)}
                </p>
              </div>
              {/* )} */}
              <div className="withdrawalCard-header border-bottom mt-20 align-items-center">
                <p className="ft-16 fw-500 Dark-Grey-Color Account Holder">
                  Tax
                </p>
                <div className="d-flex flex-col">
                  <div className="d-flex flex-row alig-items-center justify-content-space-between W-270">
                    <div
                      className="ft-16 fw-400 Dark-Grey-Color Account Holder"
                      style={{ marginRight: "93px" }}
                    >
                      State Tax
                    </div>
                    <div className="d-flex flex-row">
                      <Field
                        size="sm"
                        isRequired
                        name={`[distribution]${index}.${fields.stateTax}`}
                        type="text"
                        autoComplete="off"
                        value={data.stateTax}
                        onChange={(e) => {
                          data.stateTax = parseFloat(e.target.value);
                          sourceSplit[index] = CalculateSourceSplit(
                            index == 0
                              ? rkData
                              : sourceSplit[index - 1]["updatedSourceSplit"],
                            data,
                            withdrawal,
                            values,
                            index >= (sourceSplit?.length ?? 0) ||
                              index == (sourceSplit?.length ?? 0) - 1
                          );
                          handleChange(e);
                        }}
                        component={FieldInputPercentageBox}
                      />
                      <p
                        className="ft-16 fw-400 Dark-Grey-Color Account Holder"
                        style={{ marginLeft: "10px" }}
                      >
                        ${sourceSplit[index]?.stateTax?.toFixed(2)}
                      </p>
                    </div>
                  </div>
                  <div className="d-flex flex-row alig-items-center justify-content-space-between W-270">
                    <div
                      className="ft-16 fw-400 Dark-Grey-Color Account Holder"
                      style={{ marginRight: "75px" }}
                    >
                      Federal Tax
                    </div>
                    <div className="d-flex flex-row">
                      <Field
                        size="sm"
                        isRequired
                        name={`[distribution]${index}.${fields.federalTax}`}
                        type="text"
                        autoComplete="off"
                        value={data.federalTax}
                        onChange={(e) => {
                          data.federalTax = parseFloat(e.target.value);
                          sourceSplit[index] = CalculateSourceSplit(
                            index == 0
                              ? rkData
                              : sourceSplit[index - 1]["updatedSourceSplit"],
                            data,
                            withdrawal,
                            values,
                            index >= (sourceSplit?.length ?? 0) ||
                              index == (sourceSplit?.length ?? 0) - 1
                          );
                          handleChange(e);
                        }}
                        component={FieldInputPercentageBox}
                      />
                      <p
                        className="ft-16 fw-400 Dark-Grey-Color Account Holder"
                        style={{ marginLeft: "10px" }}
                      >
                        ${sourceSplit[index]?.federalTax?.toFixed(2)}
                      </p>
                    </div>
                  </div>
                </div>
                <p
                  className="ft-16 fw-500 Dark-Grey-Color Account Holder"
                  style={{ marginLeft: "5px" }}
                >
                  $
                  {!isEmpty(sourceSplit)
                    ? (
                        sourceSplit[index]?.federalTax +
                        sourceSplit[index]?.stateTax
                      )?.toFixed(2)
                    : 0}
                </p>
              </div>
              {(values.withdrawalType == 1 || values.withdrawalType == 2) && (
                <div className="withdrawalCard-header border-bottom mt-20 align-items-center">
                  <p className="ft-16 fw-500 Dark-Grey-Color Account-Holder">
                    Penalty
                  </p>
                  <div className="d-flex flex-col">
                    <div className="d-flex flex-row alig-items-center justify-content-space-between W-270">
                      <p className="mr-10">Waive Off Penalty ?</p>
                      <Field
                        isRequired
                        name={`[distribution]${index}.${fields.waiveOffLimitApplicable}`}
                        size="sm"
                        options={yesNoOptions}
                        selectedValue={returnOnlyIfBoolean(
                          data.waiveOffLimitApplicable
                        )}
                        onChange={(value) => {
                          setFieldValue(
                            `[distribution]${index}.${fields.waiveOffLimitApplicable}`,
                            value
                          );
                          data.waiveOffLimitApplicable = value;
                          sourceSplit[index] = CalculateSourceSplit(
                            index == 0
                              ? rkData
                              : sourceSplit[index - 1]["updatedSourceSplit"],
                            data,
                            withdrawal,
                            values,
                            index >= (sourceSplit?.length ?? 0) ||
                              index == (sourceSplit?.length ?? 0) - 1,
                            values?.withdrawEntireAmount &&
                              sourceSplit[index]?.grossWithdrawalAmount ==
                                availableAmount[index]
                              ? 1
                              : 2,
                            availableAmount[index]
                          );
                        }}
                        component={FieldButtonGroup}
                      />
                    </div>
                    {data.waiveOffLimitApplicable && (
                      <>
                        <div className="d-flex flex-row alig-items-center justify-content-space-between W-270">
                          <Field
                            size="md"
                            name={`[distribution]${index}.${fields.waiveOffLimitReason}`}
                            value={data.waiveOffLimitReason}
                            label="Reason for waiving"
                            options={waiveOffReasonOptions}
                            direction="bottom"
                            placeholder="Select a reason"
                            popupContent={
                              <SearchableList
                                label="Select a reason"
                                options={waiveOffReasonOptions}
                                onSelect={(value) =>
                                  setFieldValue(
                                    `[distribution]${index}.${fields.waiveOffLimitReason}`,
                                    value
                                  )
                                }
                                selectedValue={data.waiveOffLimitReason}
                              />
                            }
                            component={FieldDropSide}
                          />
                        </div>
                        <div className="d-flex flex-row ">
                          <Field
                            size="sm"
                            isRequired
                            name={`[distribution]${index}.${fields.waiveOffLimit}`}
                            label="Waive off percentage"
                            type="text"
                            autoComplete="off"
                            value={data.waiveOffLimit}
                            onChange={(e) => {
                              data.waiveOffLimit = parseFloat(e.target.value);
                              sourceSplit[index] = CalculateSourceSplit(
                                index == 0
                                  ? rkData
                                  : sourceSplit[index - 1][
                                      "updatedSourceSplit"
                                    ],
                                data,
                                withdrawal,
                                values,
                                index >= (sourceSplit?.length ?? 0) ||
                                  index == (sourceSplit?.length ?? 0) - 1
                              );
                              handleChange(e);
                            }}
                            component={FieldInputPercentageBox}
                          />
                          <p
                            className="ft-16 fw-400 Dark-Grey-Color Account-Holder"
                            style={{ marginTop: "35px", marginLeft: "10px" }}
                          >
                            $
                            {(
                              ((sourceSplit[index]?.requestedAmount +
                                sourceSplit[index]?.stateTax +
                                sourceSplit[index]?.federalTax +
                                totalFees) *
                                (data.waiveOffLimit ?? 0)) /
                              100
                            )?.toFixed(2)}
                          </p>
                        </div>
                      </>
                    )}
                    {data.waiveOffLimitApplicable == false ? (
                      <div className="d-flex flex-row alig-items-center justify-content-space-between W-270">
                        <div
                          className="ft-16 fw-400 Dark-Grey-Color Account Holder"
                          style={{ marginRight: "30px" }}
                        >
                          Early withdrawal penalty
                        </div>
                        <div className="d-flex flex-row ">
                          <Field
                            size="sm"
                            isRequired
                            name={`[distribution]${index}.${fields.earlyWithdrawalPenalty}`}
                            type="text"
                            autoComplete="off"
                            value={data.earlyWithdrawalPenalty}
                            onChange={(e) => {
                              data.earlyWithdrawalPenalty = parseFloat(
                                e.target.value
                              );
                              sourceSplit[index] = CalculateSourceSplit(
                                index == 0
                                  ? rkData
                                  : sourceSplit[index - 1][
                                      "updatedSourceSplit"
                                    ],
                                data,
                                withdrawal,
                                values,
                                index >= (sourceSplit?.length ?? 0) ||
                                  index == (sourceSplit?.length ?? 0) - 1
                              );
                              handleChange(e);
                            }}
                            component={FieldInputPercentageBox}
                          />
                          <p
                            className="ft-16 fw-400 Dark-Grey-Color Account Holder"
                            style={{ marginLeft: "10px" }}
                          >
                            $
                            {(
                              ((sourceSplit[index]?.requestedAmount +
                                sourceSplit[index]?.stateTax +
                                sourceSplit[index]?.federalTax +
                                totalFees) *
                                (data.earlyWithdrawalPenalty ?? 0)) /
                              100
                            )?.toFixed(2)}
                          </p>
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <p className="ft-16 fw-500 Dark-Grey-Color Account-Holder">
                    $ {sourceSplit[index]?.penalty?.toFixed(2)}
                  </p>
                </div>
              )}
              <div className="d-flex flex-row justify-content-space-between mt-20">
                <p className="ft-16 fw-400 Dark-grey-Color">Fee & Tax amount</p>
                <p className="ft-16 fw-400 Dark-grey-Color">
                  ${" "}
                  {(
                    totalFees +
                    (!isEmpty(sourceSplit)
                      ? sourceSplit[index]?.totalTaxesAndPenalty
                      : 0)
                  )?.toFixed(2)}
                </p>
              </div>
              <div className="withdrawalCard-header">
                <p className="ft-16 fw-500 Black">Gross Withdrawal Amount</p>
                <p className="ft-18 fw-600 Black">
                  <div>
                    ${" "}
                    {sourceSplit &&
                      sourceSplit[index]?.grossWithdrawalAmount?.toFixed(2)}
                  </div>
                </p>
              </div>
            </div>
          </div>
          <div className="withdrawalCard-header">
            <div
              onClick={() => {
                setsourcesplitupslide(true);
                setTransactionIndex(index);
              }}
              className="ft-16 fw-500 Light-Blue"
            >
              View Source SplitUps
            </div>
            <p className="ft-14 fw-500 Dark-grey-Color">
              {rkData?.length} sources found
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default DistributionCard;
